import { coreDefaultTheme } from '@kite-js/theme';
import { coreCitiUSTheme } from '@theme/citi/theme-citi-us';
import { ULTheme, ULThemeBuilder } from '@theme/types';

const CitiThemeBuilder: ULThemeBuilder = (cultureCode?: string, appId?: string) => {
    const theme: ULTheme = {
        ...coreDefaultTheme,
        ...coreCitiUSTheme,
        logoUrl: 'https://cdn6.agoda.net/images/kite-js/logo/citius/color-default-6.svg',
        background: {
            image: '',
            color: 'rgba(247, 247, 247, 1)',
            position: '0 0',
            size: 'contain',
        },
        faviconUrl: 'https://cdn6.agoda.net/images/mvc/default/favicon/citi/favicon.ico',
        input: {
            ...coreDefaultTheme.input,
            borderRadius: 'S',
        },
        tab: {
            ...coreDefaultTheme.tab,
            padding: '12px 8px 12px 8px',
        },
    };

    return theme;
};

export default CitiThemeBuilder;
